(function () {
  function showSearchPreloader() {
    var overlay = document.getElementById('mdSearchPreloader');
    if (!overlay) {
      return;
    }
    overlay.hidden = false;
    overlay.classList.add('is-active');
    var inner = overlay.querySelector('.preloader');
    if (inner) {
      inner.classList.add('animate');
    }
  }

  function hideSearchPreloader() {
    var overlay = document.getElementById('mdSearchPreloader');
    if (!overlay) {
      return;
    }
    overlay.classList.remove('is-active');
    overlay.hidden = true;
    var inner = overlay.querySelector('.preloader');
    if (inner) {
      inner.classList.remove('animate');
    }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('searchform')) {
      return;
    }
    showSearchPreloader();
  });

  document.addEventListener('click', function (e) {
    var tag = e.target.closest('.search-page__tag');
    var pageLink = e.target.closest('.search-page .pagination a');
    if (pageLink) {
      showSearchPreloader();
      return;
    }
    if (!tag || tag.tagName !== 'A') {
      return;
    }
    showSearchPreloader();
  });

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      hideSearchPreloader();
    }
  });
})();
